module.exports = global.config = {
    colours: {
      primary: '#2697FE',
      success: '#00ad45'
    }
  }
  